import { useEffect, useRef } from "react";
import React, { Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import FloatingContact from "@/components/FloatingContact";
import Home from "@/pages/Home";
import Countries from "@/pages/Countries";
import CountryDetail from "@/pages/CountryDetail";
import Lawyers from "@/pages/Lawyers";
import Admin from "@/pages/Admin";
import Tracking from "@/pages/Tracking";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FaqPage from "@/pages/FaqPage";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";
import { Link } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-navy-950 p-8 text-center">
          <div className="font-display text-2xl font-bold text-gold">خطایی غیرمنتظره رخ داد</div>
          <p className="text-slate-400">لطفاً صفحه را دوباره بارگذاری کنید.</p>
          <button onClick={() => window.location.reload()} className="btn-gold" data-testid="error-reload-button">بارگذاری مجدد</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-6 px-6 text-center">
      <div className="font-display text-7xl font-black gold-text">۴۰۴</div>
      <p className="max-w-md text-slate-400">صفحه‌ای که به دنبال آن هستید پیدا نشد. شاید مسیر مهاجرتی دیگری برای شما بهتر باشد!</p>
      <Link to="/" className="btn-gold" data-testid="notfound-home-link">بازگشت به صفحه اصلی</Link>
    </div>
  );
}

const ROUTE_META = {
  "/": {
    title: "گروه وکلای مهاجرت ۷ GM7 | پناهندگی و ویزای بشر دوستانه",
    desc: "گروه وکلای مهاجرت ۷ به مدیریت دکتر محمد احمدی؛ وکالت تخصصی پناهندگی و ویزای بشر دوستانه آمریکا با کیس مسیحیت و ویزای کاری کانادا، استرالیا و شنگن. مشاوره رایگان ۲۴ ساعته.",
  },
  "/countries": {
    title: "مسیرهای پناهندگی و ویزای کاری | گروه وکلای مهاجرت ۷",
    desc: "جزئیات مسیرهای پناهندگی، ویزای بشر دوستانه و ویزای کاری برای آمریکا، کانادا، استرالیا و حوزه شنگن — بدون نیاز به مدرک زبان و تمکن مالی.",
  },
  "/countries/usa": {
    title: "پناهندگی و ویزای بشر دوستانه آمریکا با کیس مسیحیت | GM7",
    desc: "تنها راه ورود قانونی به آمریکا: پناهندگی و ویزای بشر دوستانه برای اقلیت‌های قومی-مذهبی و تغییردین‌ها با کیس مسیحیت — زیر نظر دکتر محمد احمدی.",
  },
  "/countries/canada": {
    title: "پناهندگی و ویزای کاری کانادا؛ کارفرما در ۴۸ ساعت | GM7",
    desc: "پناهندگی و بشر دوستانه کانادا با کیس مذهبی و ویزای کاری با پیدا کردن کارفرما تنها در ۴۸ ساعت از سایت کاریابی گروه ۷ — بدون مدرک زبان.",
  },
  "/countries/australia": {
    title: "پناهندگی و ویزای کاری استرالیا | گروه وکلای مهاجرت ۷",
    desc: "مسیر پناهندگی و بشر دوستانه استرالیا با کیس مذهبی و ویزای کاری کارفرمایی — بدون آزمون زبان و تمکن مالی، زیر نظر دکتر محمد احمدی.",
  },
  "/countries/schengen": {
    title: "پناهندگی و ویزای کاری حوزه شنگن | گروه وکلای مهاجرت ۷",
    desc: "پناهندگی و بشر دوستانه با کیس مسیحیت و ویزای کار آلمان و فرانسه با پیدا کردن کارفرما در ۴۸ ساعت — پوشش ۲۷ کشور شنگن.",
  },
  "/lawyers": {
    title: "دکتر محمد احمدی — مدیرعامل و بنیان‌گذار گروه ۷",
    desc: "وکیل و مشاور رسمی مهاجرت در آمریکا، کانادا، استرالیا و اروپا؛ بیش از ۱۳ سال سابقه و بیش از ۲۵۰۰ پرونده موفق در کارنامه دکتر محمد احمدی.",
  },
  "/tracking": {
    title: "رهگیری آنلاین پرونده مهاجرت | گروه وکلای مهاجرت ۷",
    desc: "وضعیت پرونده خود را با کد رهگیری اختصاصی در لحظه ببینید؛ مرحله جاری، به‌روزرسانی‌ها و وکیل مسئول — ۲۴ ساعته.",
  },
  "/blog": {
    title: "وبلاگ حقوق مهاجرت و پناهندگی | گروه وکلای مهاجرت ۷",
    desc: "تحلیل‌های حقوقی و راهنماهای گام‌به‌گام پناهندگی، ویزای بشر دوستانه و ویزای کاری — به قلم تیم گروه وکلای مهاجرت ۷.",
  },
  "/faq": {
    title: "سوالات متداول مهاجرت و پناهندگی | گروه وکلای مهاجرت ۷",
    desc: "پاسخ شفاف به سوالات رایج: تسویه‌حساب پس از رسیدن، پرداخت اقساطی، مدارک زبان، تمکن مالی و کیس مسیحیت — گروه وکلای مهاجرت ۷.",
  },
  "/contact": {
    title: "تماس با گروه وکلای مهاجرت ۷ | مشاوره رایگان ۲۴ ساعته",
    desc: "درخواست مشاوره رایگان با گروه وکلای مهاجرت ۷؛ واتساپ و تماس: 725 465 8573 (1+)، تماس مستقیم: 770 7091 814 (1+) — کارشناسان ۲۴ ساعته در خدمت شما.",
  },
  "/admin": { title: "پنل مدیریت — گروه ۷", desc: "ورود مدیر گروه ۷." },
};

function routeMeta(pathname) {
  if (ROUTE_META[pathname]) return ROUTE_META[pathname];
  if (pathname.startsWith("/countries/")) return ROUTE_META["/countries"];
  if (pathname.startsWith("/blog/")) {
    return {
      title: "مقالات وبلاگ حقوق مهاجرت | گروه وکلای مهاجرت ۷",
      desc: "تحلیل تخصصی پرونده‌های پناهندگی، ویزای بشر دوستانه و کاری — گروه وکلای مهاجرت ۷.",
    };
  }
  return ROUTE_META["/"];
}

function AppShell() {
  const { pathname } = useLocation();
  const meta = routeMeta(pathname);
  return (
    <div className="relative min-h-screen overflow-x-clip bg-navy-950 font-body text-slate-100">
      <Seo title={meta.title} description={meta.desc} />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/countries/:slug" element={<CountryDetail />} />
          <Route path="/lawyers" element={<Lawyers />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/tracking" element={<Tracking />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
}

export default function App() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppShell />
        <Toaster position="bottom-center" dir="rtl" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
